import { LinkLabel } from './LinkLabel/LinkLabel'
import { NavContainer } from './NavContainer/NavContainer'
import { StyledNavLink } from './StyledNavLink/StyledNavLink'

export const Layout = {
  NavContainer,
  StyledNavLink,
  LinkLabel,
}
